import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';

export const relationshipScoreQueryLinkerSchema = z.object({
  id: z.number(),
  label: z.string(),
  icon: z.array(fileQuerySchema).nullish(),
});

export type RelationshipScoreQueryLinkerSchema = z.infer<typeof relationshipScoreQueryLinkerSchema>;
